import React from 'react';

const AuthUserContext = React.createContext('raman');

export default AuthUserContext;
